import '.gd{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ge{padding-left:1.5rem;}.ssr-plugin'
import '.gf{margin:1rem 0;}.ssr-plugin'
import '.gg{color:var(--gray-700);}.ssr-plugin'
import '.gh{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="gd ge gf gg gh"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
